import { render, staticRenderFns } from "./VehicleReport.vue?vue&type=template&id=74f87334&lang=pug&"
import script from "./VehicleReport.vue?vue&type=script&lang=ts&"
export * from "./VehicleReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports